import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type UserActivityCountVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
  currentDate: Types.Scalars['timestamp'];
}>;


export type UserActivityCount = { privateSalesCount: { aggregate: Types.Maybe<Pick<Types.Private_Sale_Aggregate_Fields, 'count'>> }, placedBidsOpenCount: { aggregate: Types.Maybe<Pick<Types.Bid_Aggregate_Fields, 'count'>> }, placedBidsEndedCount: { aggregate: Types.Maybe<Pick<Types.Bid_Aggregate_Fields, 'count'>> }, receivedBidsCount: { aggregate: Types.Maybe<Pick<Types.Auction_Aggregate_Fields, 'count'>> }, receivedOffersCount: { aggregate: Types.Maybe<Pick<Types.Offer_Aggregate_Fields, 'count'>> }, madeOffersCount: { aggregate: Types.Maybe<Pick<Types.Offer_Aggregate_Fields, 'count'>> } };



export const UserActivityCountDocument = /*#__PURE__*/ `
    query UserActivityCount($publicKey: String!, $currentDate: timestamp!) {
  privateSalesCount: private_sale_aggregate(
    where: {deadlineAt: {_gt: $currentDate}, soldAt: {_is_null: true}, _or: [{buyer: {_eq: $publicKey}}, {seller: {_eq: $publicKey}}]}
  ) {
    aggregate {
      count
    }
  }
  placedBidsOpenCount: bid_aggregate(
    where: {bidder: {_eq: $publicKey}, auction: {status: {_eq: "OPEN"}}}
    distinct_on: auctionId
  ) {
    aggregate {
      count
    }
  }
  placedBidsEndedCount: bid_aggregate(
    where: {status: {_eq: "HIGHEST"}, auction: {status: {_eq: "ENDED"}, highestBidder: {_eq: $publicKey}}}
    distinct_on: auctionId
  ) {
    aggregate {
      count
    }
  }
  receivedBidsCount: auction_aggregate(
    where: {status: {_in: ["ENDED", "OPEN"]}, bids: {seller: {_eq: $publicKey}}}
    distinct_on: auctionId
  ) {
    aggregate {
      count
    }
  }
  receivedOffersCount: offer_aggregate(
    where: {artwork: {ownerPublicKey: {_eq: $publicKey}}, acceptedAt: {_is_null: true}, canceledAt: {_is_null: true}, status: {_eq: HIGHEST}, expiresAt: {_gt: $currentDate}}
  ) {
    aggregate {
      count
    }
  }
  madeOffersCount: offer_aggregate(
    where: {buyer: {_eq: $publicKey}, acceptedAt: {_is_null: true}, canceledAt: {_is_null: true}, status: {_nin: ["EXPIRED", "CANCELED"]}, expiresAt: {_gt: $currentDate}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

export const useUserActivityCount = <
      TData = UserActivityCount,
      TError = ClientError
    >(
      variables: UserActivityCountVariables,
      options?: Omit<UseQueryOptions<UserActivityCount, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserActivityCount, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserActivityCount, TError, TData>(
      {
    queryKey: ['UserActivityCount', variables],
    queryFn: hasuraFetcher<UserActivityCount, UserActivityCountVariables>(UserActivityCountDocument, variables),
    ...options
  }
    )};

useUserActivityCount.getKey = (variables: UserActivityCountVariables) => ['UserActivityCount', variables];

export const useInfiniteUserActivityCount = <
      TData = InfiniteData<UserActivityCount>,
      TError = ClientError
    >(
      variables: UserActivityCountVariables,
      options: Omit<UseInfiniteQueryOptions<UserActivityCount, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserActivityCount, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserActivityCount, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserActivityCount.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<UserActivityCount, UserActivityCountVariables>(UserActivityCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserActivityCount.getKey = (variables: UserActivityCountVariables) => ['UserActivityCount.infinite', variables];


useUserActivityCount.fetcher = (variables: UserActivityCountVariables, options?: RequestInit['headers']) => hasuraFetcher<UserActivityCount, UserActivityCountVariables>(UserActivityCountDocument, variables, options);
